function createLightbox() {
	const dialog = document.createElement('dialog');
	dialog.className = 'image-gallery__lightbox';
	dialog.setAttribute('aria-label', 'Image viewer');
	dialog.innerHTML = `
		<figure class="image-gallery__lightbox-figure">
			<img class="image-gallery__lightbox-image" alt=""/>
			<figcaption class="image-gallery__lightbox-counter" aria-live="polite"></figcaption>
		</figure>
		<button type="button" class="image-gallery__lightbox-btn image-gallery__lightbox-close" aria-label="Close">&times;</button>
		<button type="button" class="image-gallery__lightbox-btn image-gallery__lightbox-prev" aria-label="Previous image">&#8249;</button>
		<button type="button" class="image-gallery__lightbox-btn image-gallery__lightbox-next" aria-label="Next image">&#8250;</button>
	`;

	return dialog;
}

export function initImageGallery(block) {
	const triggers = [...block.querySelectorAll('.image-gallery__trigger')];
	if (!triggers.length) return false;

	const dialog = createLightbox();
	const image = dialog.querySelector('.image-gallery__lightbox-image');
	const counter = dialog.querySelector('.image-gallery__lightbox-counter');
	const prev = dialog.querySelector('.image-gallery__lightbox-prev');
	const next = dialog.querySelector('.image-gallery__lightbox-next');
	let current = 0;
	let touchStartX = null;

	block.append(dialog);

	if (triggers.length < 2) {
		prev.hidden = true;
		next.hidden = true;
	}

	const show = (index) => {
		current = (index + triggers.length) % triggers.length;
		const trigger = triggers[current];
		const thumb = trigger.querySelector('img');

		image.src = trigger.dataset.full || thumb.src;
		image.alt = thumb.alt;
		counter.textContent = `${current + 1} / ${triggers.length}`;
	};

	triggers.forEach((trigger, index) => {
		trigger.addEventListener('click', () => {
			show(index);
			dialog.showModal();
		});
	});

	dialog.querySelector('.image-gallery__lightbox-close').addEventListener('click', () => dialog.close());
	prev.addEventListener('click', () => show(current - 1));
	next.addEventListener('click', () => show(current + 1));

	// Clicking the backdrop (the dialog itself, outside its content) closes it.
	dialog.addEventListener('click', (event) => {
		if (event.target === dialog) dialog.close();
	});

	dialog.addEventListener('keydown', (event) => {
		if (event.key === 'ArrowLeft') show(current - 1);
		if (event.key === 'ArrowRight') show(current + 1);
	});

	dialog.addEventListener('touchstart', (event) => {
		touchStartX = event.touches[0].clientX;
	}, {passive: true});

	dialog.addEventListener('touchend', (event) => {
		if (touchStartX === null) return;
		const deltaX = event.changedTouches[0].clientX - touchStartX;
		touchStartX = null;
		if (Math.abs(deltaX) > 50) show(current + (deltaX < 0 ? 1 : -1));
	});

	return true;
}

export default function imageGalleryBlock(options = {}) {
	try {
		const {block} = options;

		if (!block || block.dataset.imageGalleryReady === 'true') return;
		if (!initImageGallery(block)) return;

		block.dataset.imageGalleryReady = 'true';
	} catch (error) {
		console.error(error);
	}
}
